import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/WebAccounts/WebAccount/" );
const logoutInstance = new HttpService( "umbraco/WebAccounts/WebAccountSurface/" );

/* eslint-disable arrow-body-style */

/**
 * Determine if a user is currently logged in.
 */
export const isLoggedIn = () => {
  return instance.get( "IsLoggedIn" );
};

/**
 * Get the ID of the logged in web account.
 */
export const id = () => {
  return instance.get( "Id" );
};

/**
 * Log into the given web account.
 * @param {*} username The web account username.
 * @param {*} password The web account password.
 */
export const login = ( username, password ) => {
  return instance.post( "Login", {
    username,
    password
  } );
};

/**
 * Log out of the logged in web account.
 */
export const logout = () => {
  return logoutInstance.get( "Logout" );
};

/**
 * List web account user type parents
 */
export const webAccountUserTypeParents = () => {
  return instance.post( "ListWebAccountUserTypeParents" );
};
